/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { AnnotationSettingsTabModule } from './annotation-settings-tab.module';
export { AnnotationSettingsTabComponent } from './annotation-settings-tab.component';